import styled, { css } from 'styled-components';
import Button from 'components/Button';

export const CloseButton = styled(Button)`
  && {
    position: absolute;
    padding: 8px;
    top: 5px;
    right: 5px;
    transition: all 0.25s ease;
  }
`;

export const Content = styled.div`
  position: relative;
`;

export const AdOverlayStyled = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
  overflow: hidden;
  transition: bottom 200ms ease-in-out;
  ${(props) => {
    if (props.position === 'left') {
      return css`
        left: 0;
        right: auto;
        transform: none;
      `;
    } else if (props.position === 'right') {
      return css`
        right: 0;
        left: auto;
        transform: none;
      `;
    }

    return false;
  }};
  ${({ isNewSkin, hiddenSkin, isBigSkin }) => {
    let bottom;
    if (isNewSkin) {
      if (hiddenSkin) {
        bottom = '40px';
      } else if (isBigSkin) {
        bottom = '229px';
      } else {
        bottom = '184px';
      }
    } else {
      bottom = hiddenSkin ? '10px' : '90px';
    }

    return css`
      bottom: ${bottom};
    `;
  }};

  iframe,
  img {
    width: 100% !important;
    height: 100% !important;
  }
  div {
    max-width: 100%;
    ${(props) =>
      props.isMobile &&
      css`
        max-height: 365px;
      `};
  }

  > div {
    width: 100% !important;
  }

  ${(props) =>
    props.isMobile &&
    css`
      & {
        width: max-content;
      }
      div {
        max-width: 100%;
        max-height: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        height: auto !important;
      }

      @media screen and (orientation: landscape) {
        & {
          max-width: 370px;
        }
      }

      ${CloseButton} {
        padding: 5px;
        top: 0;
        right: 0;

        &::before {
          content: '';
          position: absolute;
          top: 5px;
          left: 5px;
          right: 5px;
          bottom: 5px;
          border-radius: 4px;
          background-color: rgba(85, 85, 85, 0.5);
        }
      }
    `};
`;
